/* MHSys Chat-Knopf: tritt zurueck, solange ein Knopf unter ihm liegt (Roadmap 3.69, Befund Enna, Inhaber 29.09.2026),
 * und laedt Gustl, den eigenen Chat-Bot, erst beim Klick (Roadmap 3.89).
 *
 * 1. Zuruecktreten. Der runde Chat-Knopf steht fest unten links und schwebt ueber dem, was darunter vorbeiscrollt.
 * Bei 375 px lag er so auf der linken Kante von "Alle 3 ins Eikaffskerberl", auf "Zur Kasse" in /cart und auf Knoepfen
 * der Startseite - wer dort tippte, oeffnete den Chat statt zu kaufen. Platz schaffen hilft dabei nicht: ein Abstand
 * unten wirkt nur am Seitenende, nicht beim Vorbeiscrollen.
 * Deshalb: liegt ein Knopf (KNOEPFE) in der Flaeche des Chat-Knopfs, setzt dieses Skript html.mhsys-chat-verdeckt,
 * und mhsys-weissblau.css blendet den Chat-Knopf so lange aus.
 *   - Shopify Inbox (<shopify-chat>): am Host, nicht nur am Knopf - Shopify legt um den Knopf eine eigene Huelle
 *     (.activator-nudge), die Tipps auch dann faengt, wenn der Knopf unsichtbar ist. Ein offenes Chatfenster
 *     (Attribut open am Host) bleibt stehen. Die Flaeche: 44 x 44 px, 20 px vom linken Rand, unten um
 *     --shopify-chat-activator-offset angehoben, aufgeloest ueber ein unsichtbares Messelement (calc(), env()).
 *     Kein Zugriff ins Shadow-DOM.
 *   - Gustl (html.mhsys-gustl-an): sein Knopf ist ein eigenes Element, die Flaeche ist einfach sein Rechteck.
 * Nur am Handy (bis 749 px), wie die uebrigen Chat-Regeln; ab 750 px bleibt alles, wie es ist.
 *
 * 2. Gustl laden. Auf jeder Seite steht nur Gustls Knopf (snippets/mhsys-gustl-knopf.liquid) - kein Chat-Skript. Ein
 * Klick auf ihn oder auf einen Link mit data-mhsys-gustl-oeffnen ("Frag an Gustl") laedt assets/mhsys-chat-bot.js und
 * sein CSS (Adressen aus window.mhsysGustl, layout/theme.liquid) und oeffnet dann das Gespraech
 * (window.mhsysGustlOeffnen). Am Rechner beginnt das Laden schon, wenn die Maus den Knopf beruehrt, damit es beim Klick
 * da ist. Ist Gustl nicht an (kein Testgeraet, Schalter aus), bleibt ein solcher Link ein normaler Link. Laedt das
 * Skript nicht, oeffnet das Kontaktformular - der Kunde soll nie ins Leere tippen.
 */
(function () {
  'use strict';

  var KNOEPFE = 'a.mhsys-knopf, button, input[type="submit"], select, [role="button"], [class*="__knopf"], .mhsys-wk__extra';
  var LINKS = 20, GROESSE = 44, RAND = 6;
  var handy = window.matchMedia('(max-width: 749px)');
  var html = document.documentElement;
  var mess = null;
  var geplant = false;
  /* Wieder zeigen erst nach so viel Ruhe beim Scrollen (Roadmap 4.30, Inhaber 09.10.2026: "Das Blinken verwirrt eher") -
     beim Vorbeiscrollen wanderten Knoepfe im Takt unter dem Chat-Knopf durch, und er ging im selben Takt aus und an.
     Ausblenden bleibt sofort (sonst oeffnet ein Tipp auf den Knopf darunter den Chat), Einblenden kommt einmal, sanft
     (Uebergang in mhsys-weissblau.css). */
  var RUHE = 600;
  var letzterScroll = 0;
  var nachRuhe = null;

  function gustlAn() {
    return html.classList.contains('mhsys-gustl-an');
  }

  function inboxFlaeche(chat) {
    if (!mess) {
      mess = document.createElement('div');
      mess.setAttribute('aria-hidden', 'true');
      mess.style.cssText = 'position:fixed;left:0;width:0;height:0;visibility:hidden;pointer-events:none;';
      document.body.appendChild(mess);
    }
    var abstand = getComputedStyle(chat).getPropertyValue('--shopify-chat-activator-offset').trim() || '20px';
    mess.style.bottom = abstand;
    var unten = mess.getBoundingClientRect().top;
    return { l: LINKS - RAND, r: LINKS + GROESSE + RAND, o: unten - GROESSE - RAND, u: unten + RAND };
  }

  /* Nur schreiben, wenn sich etwas aendert: classList.remove/toggle setzen das class-Attribut auch ohne Aenderung neu -
     das loest den MutationObserver unten aus, der wieder pruefen() plant: eine Schleife, die jedes Bild das ganze
     Dokument neu berechnen liess (Lighthouse 05.10.2026: rund 2 s Hauptthread am Handy, fast alles Layout). */
  function verdecktSetzen(an) {
    if (html.classList.contains('mhsys-chat-verdeckt') !== an) html.classList.toggle('mhsys-chat-verdeckt', an);
  }

  function pruefen() {
    geplant = false;
    var eigen = gustlAn() ? document.querySelector('.mhsys-gustl-knopf') : null;
    var chat = eigen || document.querySelector('shopify-chat');
    if (!chat || !handy.matches) { verdecktSetzen(false); return; }
    /* Steht Gustl in der Handyleiste, ist der runde Knopf am Handy aus - ausser die Kaufleiste steht (mhsys-weissblau.css).
       Dann gibt es nichts zu messen: kein getBoundingClientRect, keine erzwungene Neuberechnung des Layouts. Lighthouse
       rechnete dem Skript sonst 2,5-4 s Layout zu (Messung 05.10.2026), weil jede Klassenänderung am html beim Laden neu maß. */
    if (eigen && !html.classList.contains('mhsys-kaufleiste-an') && document.querySelector('.mhsys-handyleiste__link--gustl')) {
      verdecktSetzen(false);
      return;
    }

    var f;
    if (eigen) {
      var r = eigen.getBoundingClientRect();
      if (r.width === 0) { verdecktSetzen(false); return; }
      f = { l: r.left - RAND, r: r.right + RAND, o: r.top - RAND, u: r.bottom + RAND };
    } else {
      f = inboxFlaeche(chat);
    }
    /* Statt jeden Knopf der Seite zu vermessen (bei 3.000 Knoten teuer): nachsehen, was an fünf Punkten der Fläche liegt */
    var verdeckt = false;
    var punkte = [[f.l, f.o], [f.r, f.o], [f.l, f.u], [f.r, f.u], [(f.l + f.r) / 2, (f.o + f.u) / 2]];
    var liste = [];
    for (var j = 0; j < punkte.length; j++) {
      var x = Math.min(Math.max(punkte[j][0], 0), window.innerWidth - 1);
      var y = Math.min(Math.max(punkte[j][1], 0), window.innerHeight - 1);
      var unter = document.elementsFromPoint(x, y);
      for (var n = 0; n < unter.length; n++) {
        var kn = unter[n].closest(KNOEPFE);
        if (kn && liste.indexOf(kn) === -1) liste.push(kn);
      }
    }
    for (var i = 0; i < liste.length && !verdeckt; i++) {
      var k = liste[i];
      if (k === eigen || (eigen && eigen.contains(k))) continue;
      /* Kauf- und Handyleiste stehen unter dem Chat-Knopf, nie in seiner Flaeche; die Warenkorb-Schublade liegt ueber ihm
         (/cart steckt ebenfalls in mhsys-warenkorb und zaehlt); Gustls Fenster liegt ueber allem. */
      if (k.closest('.mhsys-kaufleiste, .mhsys-handyleiste, .mhsys-gustl')) continue;
      var q = k.getBoundingClientRect();
      if (q.width === 0 || q.height === 0) continue;
      verdeckt = q.left < f.r && q.right > f.l && q.top < f.u && q.bottom > f.o;
    }
    if (!verdeckt && html.classList.contains('mhsys-chat-verdeckt')) {
      var noch = RUHE - (Date.now() - letzterScroll);
      if (noch > 0) {
        clearTimeout(nachRuhe);
        nachRuhe = setTimeout(planen, noch + 20);
        return;
      }
    }
    verdecktSetzen(verdeckt);
  }

  function planen() {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(pruefen);
  }

  window.addEventListener('scroll', function () { letzterScroll = Date.now(); planen(); }, { passive: true });
  window.addEventListener('resize', planen);
  if (handy.addEventListener) handy.addEventListener('change', planen);
  /* Kaufleiste an/aus und Cookie-Banner aendern den Abstand des Chat-Knopfs - dann neu messen */
  new MutationObserver(planen).observe(html, { attributes: true, attributeFilter: ['class'] });
  /* Der Chat haengt sich erst nach dem Laden ein */
  window.addEventListener('load', planen);
  setTimeout(planen, 2500);
  planen();

  /* ---------------------------------------------------------------- Gustl erst beim Klick laden */
  var laden = null;

  function gustlLaden() {
    if (laden) return laden;
    var cfg = window.mhsysGustl || {};
    laden = new Promise(function (fertig, fehler) {
      if (!cfg.skript) { fehler(new Error('keine Adresse')); return; }
      if (cfg.css && !document.querySelector('link[data-mhsys-gustl-css]')) {
        var l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = cfg.css;
        l.setAttribute('data-mhsys-gustl-css', '');
        document.head.appendChild(l);
      }
      var s = document.createElement('script');
      s.src = cfg.skript;
      s.async = true;
      s.onload = function () { fertig(); };
      s.onerror = function () { laden = null; fehler(new Error('Skript')); };
      document.head.appendChild(s);
    });
    return laden;
  }

  /* Cursor gleich im Eingabefeld - nur am Rechner (Inhaber 05.10.2026: "Kein Fokus aufs Input mobil" - am Handy
     verdeckte die Tastatur den halben Bogen, bevor der Kunde Begruessung und Startfragen gesehen hatte). iOS oeffnet die Tastatur nur, wenn focus() noch im selben Tipp
     geschieht - das Chat-Skript kommt aber erst danach. Deshalb bekommt ein unsichtbares Feld den Fokus sofort im Klick
     (16 px Schrift, sonst zoomt iOS), und das Chat-Skript gibt ihn ans echte Feld weiter, sobald das Fenster steht; die
     Tastatur bleibt dabei offen. Ein Feld je Klick, aufgeraeumt vom Chat-Skript oder hier im Fehlerfall. */
  function platzhalterFokus() {
    var alt = window.mhsysGustlPlatzhalter;
    if (alt && alt.parentNode) alt.parentNode.removeChild(alt);
    var f = document.createElement('input');
    f.type = 'text';
    f.tabIndex = -1;
    f.setAttribute('aria-hidden', 'true');
    f.setAttribute('autocomplete', 'off');
    f.style.cssText = 'position:fixed;left:0;bottom:0;width:1px;height:1px;margin:0;padding:0;border:0;opacity:0;font-size:16px;';
    document.body.appendChild(f);
    try {
      f.focus({ preventScroll: true });
    } catch (err) {}
    window.mhsysGustlPlatzhalter = f;
  }

  function platzhalterWeg() {
    var f = window.mhsysGustlPlatzhalter;
    if (f && f.parentNode) f.parentNode.removeChild(f);
    window.mhsysGustlPlatzhalter = null;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var ausloeser = e.target instanceof Element ? e.target.closest('[data-mhsys-gustl-oeffnen]') : null;
    if (!ausloeser || !gustlAn()) return;
    e.preventDefault();
    /* Vorbelegter Text fuers Feld (z. B. "Ich suche ..." aus der Suche ohne Treffer) - mhsys-chat-bot.js setzt ihn ein */
    window.mhsysGustlVorgabe = ausloeser.getAttribute('data-mhsys-gustl-text') || '';
    /* Nur beim Oeffnen - ein zweiter Klick auf den Knopf schliesst das offene Fenster */
    if (!handy.matches && !html.classList.contains('mhsys-gustl-offen')) platzhalterFokus();
    ausloeser.setAttribute('aria-busy', 'true');
    gustlLaden().then(function () {
      ausloeser.removeAttribute('aria-busy');
      if (window.mhsysGustlOeffnen) window.mhsysGustlOeffnen(ausloeser);
      else platzhalterWeg();
    }).catch(function () {
      platzhalterWeg();
      ausloeser.removeAttribute('aria-busy');
      if (window.mhsysPopupOeffnen) window.mhsysPopupOeffnen('/pages/kontaktformular', 'Kontakt', { voll: true, verlauf: true, ausloeser: ausloeser });
      else window.location.href = '/pages/kontaktformular';
    });
  });

  /* Am Rechner schon beim Beruehren mit der Maus laden - nie im Leerlauf, nie per Touch (der Tipp ist der Klick) */
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' || laden || !gustlAn()) return;
    if (e.target instanceof Element && e.target.closest('[data-mhsys-gustl-oeffnen]')) gustlLaden().catch(function () {});
  }, { passive: true });
})();
